import SelectDocumentInfo from './view';
export default SelectDocumentInfo;
